/* eslint-disable no-alert -- browser dialogs implement React Native Alert on web */
// Web entry: the full App (navigation + RNE + safe-area). Native modules are
// swapped for web implementations/stubs via webpack aliases (web/webpack.config.js).
import { AppRegistry, Alert } from 'react-native'
import { App } from 'app'
import ioniconsTtf from 'react-native-vector-icons/Fonts/Ionicons.ttf'
import suitRegular from '../src/fonts/SUIT-Regular.ttf'
import suitMedium from '../src/fonts/SUIT-Medium.ttf'
import suitBold from '../src/fonts/SUIT-Bold.ttf'
import suitExtraBold from '../src/fonts/SUIT-ExtraBold.ttf'

// react-native-web's Alert is a no-op. Bridge Alert.alert to window.alert/confirm
// so both info dialogs (errors) and button confirmations (장소 삭제, 회원탈퇴)
// work on web. Covers every Alert.alert caller (infra/util + direct).
Alert.alert = (title, message, buttons) => {
  const text = [title, message].filter(Boolean).join('\n\n')
  if (!buttons || buttons.length <= 1) {
    window.alert(text)
    if (buttons && buttons[0] && buttons[0].onPress) buttons[0].onPress()
    return
  }
  const cancelBtn = buttons.find((b) => b.style === 'cancel')
  const confirmBtn =
    buttons.find((b) => b.style !== 'cancel') || buttons[buttons.length - 1]
  if (window.confirm(text)) {
    if (confirmBtn && confirmBtn.onPress) confirmBtn.onPress()
  } else if (cancelBtn && cancelBtn.onPress) {
    cancelBtn.onPress()
  }
}

// Load the Ionicons web font so icons (bottom tab bar, mypage) render as real
// glyphs instead of placeholders. Font-family must match the icon stub's.
const ioniconsFontFace = document.createElement('style')
ioniconsFontFace.textContent =
  "@font-face{font-family:'Ionicons';src:url(" +
  ioniconsTtf +
  ") format('truetype');font-weight:normal;font-style:normal;}"
document.head.appendChild(ioniconsFontFace)

// SUIT is linked on native via react-native-asset; web needs @font-face or
// `font-family: SUIT` falls back (and SUIT's icon-aligned metrics never apply).
const suitFontFace = document.createElement('style')
suitFontFace.textContent = [
  [suitRegular, 400],
  [suitMedium, 500],
  [suitBold, 700],
  [suitExtraBold, 800],
]
  .map(
    ([src, weight]) =>
      "@font-face{font-family:'SUIT';src:url(" +
      src +
      ') format(\'truetype\');font-weight:' +
      weight +
      ';font-style:normal;font-display:swap;}',
  )
  .join('')
document.head.appendChild(suitFontFace)

AppRegistry.registerComponent('GogoApp', () => App)
AppRegistry.runApplication('GogoApp', {
  rootTag: document.getElementById('root'),
})
